const initialState = {
  cities: [],
  selectedCity: [],
};
export default initialState;
